import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon } from '@heroicons/react/solid';
import Link from 'next/link';
import Raffle from './Raffle';
import Alert from './Alert';
import config from '../config';

function TheRafflePage({ raffle }) {
  const [backButtonHovered, setBackButtonHovered] = useState(false);

  return (
    <div className='max-w-[90rem] mx-auto space-y-10 px-6'>
      <div>
        <div className='inline-flex'>
          <Link href='/raffles'>
            <a
              className='flex items-center space-x-3 font-bold transition-colors duration-200 hover:text-primary-500'
              onMouseEnter={() => setBackButtonHovered(true)}
              onMouseLeave={() => setBackButtonHovered(false)}
            >
              <motion.div className='w-6 -mb-[2px]' animate={{ x: backButtonHovered ? -5 : 0 }}>
                <ChevronLeftIcon />
              </motion.div>
              <span>All Raffles</span>
            </a>
          </Link>
        </div>
      </div>
      {raffle ? (
        <Raffle raffle={raffle} />
      ) : (
        <div className='max-w-md col-span-1 col-start-2 mx-auto space-y-10'>
          <Alert type='danger'>
            <div>No raffle found</div>
          </Alert>
          <p className='text-[24px] text-center max-w-sm mx-auto'>
            <a href={config.discord} target='_blank' rel='noreferrer' className='font-bold text-primary-500'>
              Join Discord
            </a>{' '}
            for more information or if you need any help.
          </p>
        </div>
      )}
    </div>
  );
}

export default TheRafflePage;
